import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-481df849"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href", "fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: "svg-icon",
    style: _normalizeStyle({ fontSize: _ctx.size + 'px', color: _ctx.color })
  }, [
    _createElementVNode("use", {
      "xlink:href": `#icon-${_ctx.name}`,
      fill: _ctx.color
    }, null, 8, _hoisted_1)
  ], 4))
}